import React from 'react';
import { useModal } from '../../context/ModalContext';
import ModalSicaiPlans from './ModalSicaiPlans';
import ModalDeConect from './ModalDeConect';
import ModalAddendas from './ModalAddendas';
import ModalAsesor from './ModalAsesor';
import ModalLegal from './ModalLegal';
import ModalDenuncia from './ModalDenuncia';
import ModalRecuperarPassword from './ModalRecuperarPassword';

const ModalManager = () => {
  const { activeModal, modalData, closeModal } = useModal();

  if (!activeModal) return null;

  switch (activeModal) {
    case 'plans':
      return <ModalSicaiPlans isOpen={true} onClose={closeModal} />;

    case 'deconect':
      return <ModalDeConect isOpen={true} onClose={closeModal} />;

    case 'addendas':
      return <ModalAddendas isOpen={true} onClose={closeModal} />;

    case 'asesor':
      return <ModalAsesor isOpen={true} onClose={closeModal} initialData={modalData} />;

    case 'sla':
    case 'privacy':
    case 'terms':
    case 'contract':
    case 'arco':
      return <ModalLegal isOpen={true} onClose={closeModal} docType={activeModal} />;

    case 'denuncia':
      return <ModalDenuncia isOpen={true} onClose={closeModal} />;

    case 'recuperarSicai':
      return <ModalRecuperarPassword isOpen={true} onClose={closeModal} tipo="SICAI" />;

    case 'recuperarDeConnect':
      return <ModalRecuperarPassword isOpen={true} onClose={closeModal} tipo="DeConnect" />;

    case 'recuperar':
      return <ModalRecuperarPassword isOpen={true} onClose={closeModal} tipo={modalData?.tipo || 'SICAI'} />;

    default:
      return null;
  }
};

export default ModalManager;
